if (!customElements.get('adelaide-flavour-gallery')) {
  customElements.define('adelaide-flavour-gallery', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      const grid = this.querySelector('.adelaide-flavour-gallery__grid');
      if (!grid) return;

      [...grid.children]
        .sort((a, b) => Number(a.dataset.priority || 999) - Number(b.dataset.priority || 999))
        .forEach((card) => grid.append(card));

      const filters = this.querySelector('.adelaide-flavour-gallery__filters');
      if (filters) {
        const existing = new Set([...filters.querySelectorAll('button[data-filter]')].map((button) => button.dataset.filter));
        const preferred = ['halal', 'kosher', 'nut-free', 'vegan', 'gluten-free', 'contains-nuts'];
        const extras = [];
        this.querySelectorAll('.adelaide-flavour-tag').forEach((tag) => {
          const handle = tag.dataset.handle || (tag.getAttribute('aria-label') || tag.textContent).trim().toLowerCase().replace(/\s+/g, '-');
          const label = (tag.getAttribute('aria-label') || tag.textContent).trim();
          if (!handle || !label || existing.has(handle)) return;
          existing.add(handle);
          extras.push({ handle, label });
        });
        extras.sort((a, b) => {
          const ai = preferred.indexOf(a.handle);
          const bi = preferred.indexOf(b.handle);
          return (ai === -1 ? 99 : ai) - (bi === -1 ? 99 : bi);
        }).forEach(({ handle, label }) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.dataset.filter = handle;
          button.setAttribute('aria-pressed', 'false');
          button.textContent = label;
          filters.append(button);
        });
        filters.hidden = filters.querySelectorAll('button').length < 2;
        filters.addEventListener('click', (event) => {
          const button = event.target.closest('button[data-filter]');
          if (!button) return;
          filters.querySelectorAll('button').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
          let visible = 0;
          this.querySelectorAll('[data-categories]').forEach((card) => {
            card.hidden = !!button.dataset.filter && !(card.dataset.categories || '').trim().split(/\s+/).includes(button.dataset.filter);
            if (!card.hidden) visible += 1;
          });
          const empty = this.querySelector('[data-empty]');
          if (empty) empty.hidden = visible > 0;
        }, { signal });
      }

      const coarsePointer = window.matchMedia('(hover: none)').matches;
      this.querySelectorAll('[data-flippable]').forEach((card) => {
        const setFlipped = (flipped) => {
          card.classList.toggle('is-flipped', flipped);
          card.setAttribute('aria-expanded', String(flipped));
        };
        if (coarsePointer) {
          card.addEventListener('click', (event) => {
            if (event.target.closest('a, button')) return;
            setFlipped(!card.classList.contains('is-flipped'));
          }, { signal });
        }
        card.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          setFlipped(!card.classList.contains('is-flipped'));
        }, { signal });
        card.addEventListener('blur', () => {
          if (!coarsePointer) setFlipped(false);
        }, { signal });
      });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
